var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5017 1.92163H37.635L24.235 17.2383L40 38.0766H27.6567L17.99 25.4366L6.92667 38.0766H0.79L15.1233 21.6933L0 1.9233H12.6567L21.395 13.4766L31.5017 1.92163ZM29.35 34.4066H32.7483L10.81 5.39996H7.16333L29.35 34.4066Z",
    fill: "#FFF9F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.a0d0682e190b40719b49e871e7d7bd3f.svg";
export { ForwardRef as ReactComponent };